import { getUserId } from '../../store.js'
import PhoneAuthInput from '../../util/phone-auth/PhoneAuthInput.js'
import { InputValidator } from '../../util/input-validate/inputValidation.js'
import { SignUpViewChanger} from "../../util/view-changer/index.js";

const PhoneAuth = () => {
    // phone auth input component
    let phoneAuth = undefined

    /**
     * @typedef {'prepend' | 'append' | 'before' | 'after' | 'html'} RenderOption
     */

    /**
     * init component
     * @param {{target: jQuery | HTMLElement | string, renderOption: RenderOption}} props
     */
    const init = (props) => {
        render(props.target, props.renderOption)
        setEvent(props.target)
    }

    /**
     * get html template
     * @return {string}
     */
    const template = () => {
        return `
            <div>
                <div class="js-interactive-form-wrap interactive-form-wrap">
                    <input 
                        id="phoneNumberInput"
                        class="interactive-form-input join-phone-input"
                        type="text"
                        inputmode="numeric"
                        maxlength="20"
                        pattern="[0-9\\+\\-]"
                        tabindex="3"
                        autocomplete="off"
                        placeholder=""
                    />
                    <span class="interactive-form-placeholder">${i18next.t(dictionary.phoneNumber)}</span>
                </div>
                <button class="js-phone-auth-button phone-confirm-button new-pp-btn" disabled>
                    ${i18next.t(dictionary.verify)}
                </button>
            </div>
            <div class="js-phone-error-wrap error-txt-wrap">
                <span class="error-text">${i18next.t(main.phoneNumber.checkPhoneNumber)}</span>
            </div>
            <div class="js-auth-code-wrap phone-auth-wrap" style="display: none;">
                <div class="js-interactive-form-wrap interactive-form-wrap">
                    <input
                        id="authCodeInput"
                        class="interactive-form-input phone-certi-input"
                        type="text"
                        inputmode="numeric"
                        maxlength="6"
                        pattern="[0-9]"
                        tabindex="4"
                        autocomplete="off"
                        placeholder=""
                    />
                    <span class="interactive-form-placeholder">${i18next.t(common.confirmVerificationCode)}</span>
                </div>
                <div class="js-counter-wrap count-wrap">
                    <span class="js-counter-message">${i18next.t(main.verificationSent)}</span>
                    <span class="js-counter-remaining">00:00</span>
                </div>
            </div>
        `
    }

    /**
     * render component
     * @param {jQuery | HTMLElement | string} target
     * @param {RenderOption} option
     */
    const render = (target, option= 'html') => {
        const html = template()

        if (option === 'prepend') {
            target.prepend(html)
        }

        if (option === 'append') {
            target.append(html)
        }

        if (option === 'before') {
            target.before(html)
        }

        if (option === 'after') {
            target.after(html)
        }

        if (option === 'html') {
            target.html(html)
        }
    }

    /**
     * set event to component
     * @param {jQuery | HTMLElement | string} target
     */
    const setEvent = (target) => {
        const $phoneAuthInput = target.find('#phoneNumberInput')
        const $phoneAuthButton = target.find('.js-phone-auth-button')
        const $phoneAuthError = target.find('.js-phone-error-wrap')

        const $authCodeWrap = target.find('.js-auth-code-wrap')
        const $authCodeInput = target.find('#authCodeInput')
        const $authCountWrap = target.find('.js-counter-wrap')
        const $authCountMessage = target.find('.js-counter-message')
        const isUserProfileView = SignUpViewChanger.getViewId() === 'userProfileInput';
        const sectionId = isUserProfileView ? 'profileInputSection' : 'invitationUserFormSection';
        const $profileInputSection = $(`#${sectionId}`);
        const $nextButton = $profileInputSection.find(".js-next-page-button");

        // phone number input
        $phoneAuthInput.on({
            keyPress: (e) => {
                PhoneNumKeyEvent.validNumOnKeypress(e)
            },
            keyup: (e) => {
                // enter key for submit
                const enterKeys = new Set(['Enter', 'NumpadEnter'])
                if (enterKeys.has(e.code) && $phoneAuthButton.attr('disabled') !== 'disabled') {
                    $phoneAuthButton.trigger('click')
                    return
                }

                PhoneNumKeyEvent.validNumOnKeyUp(e)

                // reset auth area
                $phoneAuthButton.text(i18next.t(dictionary.verify))
                $authCodeWrap.hide()
                $authCountWrap.hide()
                $nextButton.attr('disabled', true)

                // check component state
                if (typeof phoneAuth !== 'undefined') {
                    phoneAuth.reset()
                }

                // consider empty string as valid value
                if (e.target.value === '') {
                    $phoneAuthError.hide()
                    $phoneAuthButton.attr('disabled', true)
                    $phoneAuthInput.closest('.js-interactive-form-wrap').removeClass('interactive status-error')
                    return
                }

                $phoneAuthInput.closest('.js-interactive-form-wrap').addClass('interactive')

                // valid
                if (validatePhoneNumber(e.target.value, 10, 20)) {
                    $phoneAuthError.hide()
                    $phoneAuthButton.attr('disabled', false)
                    $phoneAuthInput.closest('.js-interactive-form-wrap').removeClass('status-error')
                    return
                }

                // invalid
                $phoneAuthError.show()
                $phoneAuthButton.attr('disabled', true)
                $phoneAuthInput.closest('.js-interactive-form-wrap').addClass('status-error')
            }
        })

        // send auth code request
        $phoneAuthButton.on('click', (e) => {
            // check name & password input
            const $inputs = $profileInputSection.find('.js-join-input')
            if (!InputValidator.inputsValidate($inputs)) {
                return
            }

            $authCodeInput.val('')
            $phoneAuthButton.text(i18next.t(dictionary.resend))

            // check component state
            if (typeof phoneAuth !== 'undefined') {
                phoneAuth.reset()
            }

            // init component
            phoneAuth = PhoneAuthInput({
                userId: getUserId(),
                phoneNumber: $phoneAuthInput.val(),
                deviceData: Often.getDeviceJson(_CLIENT_IP),
                timeLimit: '3',
            })
            phoneAuth.init()

            $authCodeWrap.show()
            $authCountWrap.show()
            $authCodeInput.focus()
        })

        // auth code input
        $authCodeInput.on({
            keypress: handleAuthInputKeyPressEvent,
            keyup: (e) => {
                // enter key for submit
                const enterKeys = new Set(['Enter', 'NumpadEnter'])
                if (enterKeys.has(e.code)) {
                    $nextButton.trigger('click')
                    return
                }

                handleAuthInputKeyUpEvent(e)

                $authCodeInput.closest('.js-interactive-form-wrap').removeClass('status-error')

                // consider empty string as valid value
                const authCode = $authCodeInput.val()
                if (authCode === '') {
                    $nextButton.attr('disabled', true)
                    $authCodeInput.closest('.js-interactive-form-wrap').removeClass('interactive')
                    return
                }

                $authCodeInput.closest('.js-interactive-form-wrap').addClass('interactive')

                // validate auth code
                if (!validateAuthCode(authCode)) {
                    $nextButton.attr('disabled', true)
                    return
                }

                // valid
                $nextButton.attr('disabled', false)
            },
            input: (e) => {
                $(e.target).trigger('keyup')
            }
        })
    }

    /**
     * validate phone number with specific format and length limit
     * @param {string} inputValue - phone number
     * @param {number} min - min length
     * @param {number|undefined} max - max length (optional)
     * @return {boolean}
     */
    const validatePhoneNumber = (inputValue, min, max) => {
        // create quantifier
        let quantifier = ''
        if (typeof min !== 'undefined') {
            quantifier = typeof max !== 'undefined' ? `{${min},${max}}` : `{${min},}`
        }

        // check regex
        const regex = new RegExp(`^[+\\-0-9]${quantifier}$`)
        return regex.test(inputValue)
    }

    /**
     * handle keyup event on auth code input
     * @param {KeyboardEvent} event
     */
    const handleAuthInputKeyUpEvent = (event) => {
        const authCode = event.target.value
        const regex = new RegExp(/^[0-9]$/)
        if (!regex.test(authCode)) {
            $(event.target).val(authCode.replace(/[^0-9]/g, ''))
        }
    }

    /**
     * handle keypress event on auth code input
     * @param {KeyboardEvent} event
     */
    const handleAuthInputKeyPressEvent = (event) => {
        const keyCode = event.which || event.keyCode
        const controlKeys = new Set([8, 9, 13, 16, 17, 39, 46, 187])

        const isControlKey = event.ctrlKey || controlKeys.has(keyCode)
        const isNumberKey = keyCode >= 48 && keyCode <= 57
        if (!isNumberKey && !isControlKey) {
            event.preventDefault()
        }
    }

    /**
     * validate auth code
     * @param {string} authCode
     * @return {boolean}
     */
    const validateAuthCode = (authCode) => {
        // check regex
        const regex = new RegExp(/^[0-9]{6}$/)
        return regex.test(authCode)
    }

    /**
     * (for external use only) validate phone auth inputs
     */
    const validatePhoneAuthInputs = () => {
        const $phoneAuthInput = $('#phoneNumberInput')
        const $authCodeInput = $('#authCodeInput')
        const phoneNumber = $phoneAuthInput.val()
        const authCode = $authCodeInput.val()

        if (phoneNumber.length === 0 || !validatePhoneNumber(phoneNumber, 10, 20)) {
            $phoneAuthInput.focus()
            return
        }

        if (authCode.length === 0 || !validateAuthCode(authCode)) {
            $authCodeInput.focus()
        }
    }

    /**
     * (for external use only) verify phone auth code
     */
    const verifyAuthCode = async () => {
        return await phoneAuth.confirm()
    }

    /**
     * (for external use only) stop counter after verification complete
     */
    const stopCounter = () => {
        phoneAuth.reset()
    }

    return {
        init,
        validatePhoneAuthInputs,
        verifyAuthCode,
        stopCounter,
    }
}

export default PhoneAuth

